import '../input/button-input';

import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { cache } from 'lit/directives/cache.js'

@customElement('view-switcher')
export class ViewSwitcher extends LitElement {

    // Props

    @property({ type: Array })
    titles: string[] = [];

    @property({ type: Number })
    activeIndex: number = 0;

    @state()
    _views: string[] = [];    

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();

        // add classes
        this.classList.add('ViewSwitcher');

        // slots
        const slots: Element[] = [...this.querySelectorAll('[slot="view"]')];
        this._views = slots.map((slot) => slot.innerHTML);
        slots.forEach((slot) => slot.remove());
    }

    // Render

    render() {
        return html`
            <nav class="ViewSwitcher-nav">
                ${ this.titles.map((title,i) => { 
                    return html`
                        <button-input
                            name="view"
                            .active="${ i == this.activeIndex }"
                            @click="${() => this._toggle(i) }">
                            <div slot="label">
                                ${ title }
                            </div>
                        </button-input>
                    `;
                })}
            </nav>
            <div class="Gallery-body">
                ${ cache(unsafeHTML(this._views[this.activeIndex ?? ''])) }
            </div>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    private _toggle(i) {
        this.activeIndex = i;
    }

}